import { MarkdownContent } from '@/components/ui/markdown-content'
import { cn } from '@/lib/utils'

/**
 * Quiet scale for a sidebar notice. Every level stays `text-sm leading-5`.
 * This does not use the field heading scale.
 */
const NOTICE_MARKDOWN_CLASS = [
  'break-words text-left text-sm leading-5',
  'prose-h1:mt-0 prose-h1:mb-1 prose-h1:pb-0 prose-h1:font-sans prose-h1:text-sm prose-h1:font-semibold prose-h1:leading-5 prose-h1:tracking-normal prose-h1:text-inherit',
  'prose-h2:mt-0 prose-h2:mb-1 prose-h2:pb-0 prose-h2:font-sans prose-h2:text-sm prose-h2:font-semibold prose-h2:leading-5 prose-h2:tracking-normal prose-h2:text-inherit',
  'prose-h3:mt-0 prose-h3:mb-1 prose-h3:pb-0 prose-h3:font-sans prose-h3:text-sm prose-h3:font-semibold prose-h3:leading-5 prose-h3:tracking-normal prose-h3:text-inherit',
  'prose-h4:mt-0 prose-h4:mb-1 prose-h4:pb-0 prose-h4:font-sans prose-h4:text-sm prose-h4:font-semibold prose-h4:leading-5 prose-h4:tracking-normal prose-h4:text-inherit',
  'prose-h5:mt-0 prose-h5:mb-1 prose-h5:pb-0 prose-h5:font-sans prose-h5:text-sm prose-h5:font-semibold prose-h5:leading-5 prose-h5:tracking-normal prose-h5:text-inherit',
  'prose-h6:mt-0 prose-h6:mb-1 prose-h6:pb-0 prose-h6:font-sans prose-h6:text-sm prose-h6:font-semibold prose-h6:leading-5 prose-h6:tracking-normal prose-h6:text-inherit',
  'prose-p:mt-0 prose-p:!mb-1 prose-p:py-0 prose-p:text-sm prose-p:leading-5 prose-p:text-inherit',
  'prose-ul:my-1 prose-ul:text-sm prose-ol:my-1 prose-ol:text-sm',
  'prose-li:text-sm prose-li:leading-5 prose-strong:text-sm prose-em:text-sm prose-a:text-sm',
].join(' ')

export function NoticeMarkdown({
  children,
  className,
}: {
  children: string
  className?: string
}) {
  return <MarkdownContent className={cn(NOTICE_MARKDOWN_CLASS, className)}>{children}</MarkdownContent>
}
